module.exports = __webpack_public_path__ + "13b60a0d39e877e17a593302006b7f60.jpg";